import { LeaderboardStats } from "@ecologi/shared";

interface LeaderboardPosition {
  leaderboardType: string;
  position: string;
}

export const rankMapper = (rank: number, leaderboardType?: string): string => {
  if (rank < 10) {
    return `${leaderboardType === "sparkly" ? "Sparkly" : "Ranked"} #${
      rank + 1
    }`;
  } else if (rank < 20) {
    return "Top 20";
  } else if (rank < 30) {
    return "Top 30";
  } else if (rank < 40) {
    return "Top 40";
  }
  return "Top 100";
};

// Uses the leaderboard stats to see if the user is in the top 50
export const getLeaderboardPosition =
  (lbData: LeaderboardStats | null) =>
  (username: string): LeaderboardPosition | null => {
    if (!lbData) {
      return null;
    }

    const keys = Object.keys(lbData); // leaderboard types

    let highestRank: null | number = null;
    let leaderboardType: null | string = null;

    keys.forEach((key) => {
      const userData = lbData[key];
      const idx = userData.findIndex((user) => user.username === username);
      if (idx >= 0 && (highestRank === null || idx < highestRank)) {
        highestRank = idx;
        leaderboardType = key;
      }
    });

    return highestRank !== null && leaderboardType
      ? {
          position: rankMapper(highestRank, leaderboardType),
          leaderboardType,
        }
      : null;
  };
